import React, { Component } from "react";

import ProjPeopleContent from "../../ProjPeopleContent";

import colors from "../../colors";
// import menu from "../data/data";//menu
import Slider from "./Slider";

// import ReactHtmlParser from 'react-html-parser';

const projTeam = {
  header: [
    "Deputy Project Director",
    "Principal Investigator",
    "Co-investigators",
    "Team Lead",
    "Team Members",
    "Research Scientists",
    "Research Fellows",
  ],
  rows: {
    row1: [
      "-",
      "",
      "",
      "Sri. P.V.S.S.N Gopalakrishna, S/E 'SG', T&ED",
      "Sri. T.S. Viswanadham, Sc./ Engr. 'SF', T&ED",
      "",
      "",
    ],
    row2: ["", "", "", "", "Sri. P.Hariesh, S/E 'SE', T&ED", "", ""],
    row3: [
      "",
      "",
      "",
      "",
      "Ms. Annie Maria Issac, S/E 'SD', WRAD, WRG",
      "",
      "",
    ],
  },
};
export default class TRProjTeam extends Component {
  render() {
    return (
      <div
        className="ui raised segment"
        style={{
          marginTop: "0em",
          padding: "0px",
          marginLeft: "20%",
          marginRight: "20%",
        }}
      >
        <div
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            backgroundColor: colors.background,
          }}
        >
          <Slider />
          {/* <MDBCard style={{ width: "100%", }}>
            <MDBCardBody> */}
          <main style={{ flexGrow: "1", overflowX: "auto" }}>
            <div className="card" style={{ width: "100%", height: "500px" }}>
              <main style={{ flexGrow: "1", overflowX: "auto" }}>
                <div className="card" style={{ width: "100%", height: "100%" }}>
                  <div className="card-body">
                    <ProjPeopleContent data={projTeam} width="80%" />
                  </div>
                </div>
              </main>
            </div>
          </main>
          {/* </MDBCardBody>
        </MDBCard> */}
        </div>
      </div>
    );
  }
}
